import { WidgetModel, DashboardModel } from "src/modules/base/components/dashboard-master/models/dashboard.model";
import { Component, OnInit, ElementRef, Input } from "@angular/core";
import { ActivatedRoute } from '@angular/router';
import { BaseService } from '../../shared/services/base.service';
import { DashboardService } from "../dash-board/services/dashboard.service";

@Component({
    selector: 'app-dashboard-sidebar',
    templateUrl: './dashboard-sidebar.component.html',
    standalone: false
})
export class DashboardSidebarComponent implements OnInit {
	selectedWidgetType: any = 'Widget Type';
	constructor(private baseService: BaseService,public dashboardService:DashboardService, private route: ActivatedRoute, private elementRef: ElementRef) { };
@Input('widgetList') deletedWidgets: any = [];
	// Components variables
	type: any;
	public toggle: boolean;
	public modal: boolean;
	public widgetCollection: any[];
	public widgetByGroup: any[] = [];
	public groups: any[] = [];
	public dashboardCollection: DashboardModel[];


	ngOnInit(): void {
		if(this.deletedWidgets.length==0){
		this.baseService.get('GET_ALL', '', 'widget_master', 'account-management').subscribe(widgetType => {

			this.groups = widgetType.resource
			if(this.groups){
				this.groups.sort((a, b) => a.widget_name > b.widget_name ? 1 : -1)
			}			
			console.log("widgetType",widgetType)
		});
		this.baseService.get('GET_DATA', '', 'widget_config', 'account-management').subscribe(widgets => {
			widgets.resource.sort((a, b) => a.widget_name > b.widget_name ? 1 : -1)
			this.widgetCollection = widgets.resource;
		});

		// this._ds.getDashboards().subscribe(dashboards => {
		// 	this.dashboardCollection = dashboards;
		// });
	}
}

	onDrag(event, widget,i) {

		event.dataTransfer.setData('widget', JSON.stringify({...widget,index:i}));
		// this.elementRef.nativeElement.querySelector('#drop_toggle').classList.toggle('show')
	}

	getWidgetByType(event,entry){
		// this.widgetByGroup = this.widgetCollection.slice().filter(res=>{return res.name ==event.name})
		// this.selectedWidgetType = event
		event.dataTransfer.setData('widget', JSON.stringify(this.dashboardService.prepreateWidgetData(entry)));
	}
	widgetsAvailable(entry){
		if(this.widgetCollection.slice().filter(res=>( res.name ==entry.name)).length>0)
		return true
		else 
		return false
	}
}

